export default __webpack_public_path__ + "static/media/registration-third-party-auth.7ea622e3.png";